import { Box, Flex, HStack, VStack } from '@chakra-ui/react';
import CanopyButton from '../../canopy-ui-components/components/CanopyButton/CanopyButton';
import { useCurrentColors } from '../../canopy-ui-components/hooks/UseCurrentColors/UseCurrentColors';
import EditInfoRow from './EditInfoRow';

const EditInfo = ({
    inputInfo,
    globalProps,
    handleEditInfo,
    addNewInfo,
    deleteInfo,
}: any) => {
    const { t } = globalProps;
    const currentColors = useCurrentColors();
    return (
        <>
            {inputInfo ? (
                <>
                    <VStack
                        spacing="15px"
                        mb="15px">
                        <>
                            <HStack
                                spacing="15px"
                                mt="15px"
                                pl="20px"
                                width="100%">
                                <Flex
                                    width="300px"
                                    minWidth="300px">
                                    <Box
                                        fontSize="16px"
                                        fontWeight="bold">
                                        {t('ui.mm.table-headers.security-name')}
                                    </Box>
                                </Flex>
                                <Flex
                                    width="200px"
                                    minWidth="200px"
                                    align="flex-start">
                                    <Box
                                        fontSize="16px"
                                        fontWeight="bold">
                                        {t('table-headers.ticket-ref')}
                                    </Box>
                                </Flex>
                                <Flex
                                    flexGrow={1}
                                    width="100%"
                                    align="flex-start">
                                    <Box
                                        fontSize="16px"
                                        fontWeight="bold">
                                        {t(
                                            'ui.mm.table-headers.additional_info'
                                        )}
                                    </Box>
                                </Flex>
                                <CanopyButton
                                    onClick={addNewInfo}
                                    height="30px"
                                    width="100%"
                                    data-test="add-key-values"
                                    variant="outline"
                                    fontSize="sm">
                                    {t('ui.mm.add-key-values')}
                                </CanopyButton>
                            </HStack>
                            <VStack
                                key={`${inputInfo?.security_name}`}
                                spacing="15px"
                                width="100%"
                                border={`1px solid ${currentColors.componentBorder}`}
                                borderRadius={'4px'}
                                padding="20px"
                                justify="flex-start"
                                alignItems="flex-start">
                                <HStack
                                    spacing="15px"
                                    width="100%"
                                    justify="flex-start"
                                    alignItems="flex-start">
                                    <VStack
                                        width="300px"
                                        minWidth="300px"
                                        spacing="15px"
                                        justify="flex-start"
                                        alignItems="flex-start">
                                        <Box>{inputInfo?.security_name}</Box>
                                    </VStack>
                                    <VStack
                                        width="200px"
                                        minWidth="200px"
                                        spacing="15px"
                                        justify="flex-start"
                                        alignItems="flex-start">
                                        <Box>{inputInfo?.ticketref}</Box>
                                    </VStack>
                                    <VStack
                                        spacing="15px"
                                        width="100%"
                                        justifyContent="flex-start"
                                        pt="10px"
                                        pr="10px">
                                        {inputInfo?.additionalInfo?.length &&
                                            inputInfo?.additionalInfo.map(
                                                (item: any, index: number) => (
                                                    <EditInfoRow
                                                        item={item}
                                                        key={index}
                                                        index={index}
                                                        updateItem={
                                                            handleEditInfo
                                                        }
                                                        deleteItem={deleteInfo}
                                                        globalProps={
                                                            globalProps
                                                        }></EditInfoRow>
                                                )
                                            )}
                                    </VStack>
                                </HStack>
                            </VStack>
                        </>
                    </VStack>
                </>
            ) : null}
        </>
    );
};

export default EditInfo;
